import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';

export type SimpleCardProps = {
  title: string;
  subtitle: string;
  href: string;
  className?: string;
};

const SimpleCard = ({className, title, subtitle, href}: SimpleCardProps) => {
  return (
    <Link
      href={href}
      className={classNames(
        'flex flex-col text-start bg-primary-700 hover:bg-primary-600 p-md rounded-3xl cursor-pointer',
        className
      )}
    >
      <div className={'text-xs text-primary-300 font-medium grow'}>{subtitle}</div>
      <div className={'text-lg text-white font-semibold mb-2'}>{title}</div>
    </Link>
  );
};

export default SimpleCard;
